import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { Amplify } from "aws-amplify";
import config from "./amplifyconfiguration.json";
import apiConfig from "./aws-sync-exports-auth.json";
import { initRum } from "./utils/rum";

const awsConfig = Object.assign(config, apiConfig);

// ローカル開発時: REACT_APP_APPSYNC_ENDPOINT が設定されていれば
// ローカル AppSync シミュレータを向く。
if (process.env.REACT_APP_APPSYNC_ENDPOINT) {
  awsConfig.aws_appsync_graphqlEndpoint =
    process.env.REACT_APP_APPSYNC_ENDPOINT;
}

Amplify.configure(awsConfig);
initRum();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
